module.exports = __webpack_public_path__ + "img/border_rectangle.e0def212.svg";